import createEnhancer, { divWrapper } from 'react-universal-interface/lib/createEnhancer';
export { divWrapper };
export default createEnhancer;
